const isDev = process.env.NEXT_PUBLIC_IS_DEV?.toString() === 'true'
const isLocal = true
const currentDomain = isDev
  ? 'https://dev.edugram.io'
  : 'https://www.edugram.io'

export { isDev, isLocal, currentDomain }
